import * as constant from '../constant.js';
/*
 * All reducers get two parameters passed in, state and action that occurred
 *       > state isn't entire apps state, only the part of state that this reducer is responsible for
 * */

// "state = null" is set so that we don't throw an error when app first boots up
export default function (state = {username:"", isLoggedIn:false, customerId:"", authToken:""}, action) {
            let newState = {};
            switch (action.type) {

            case constant.USER_LOGIN:
                newState.username = action.payload.username;
                newState.customerId = action.payload.customerId;
                newState.authToken = action.payload.authToken;
                newState.isLoggedIn = true;
                localStorage.setItem("username",action.payload.username);
                localStorage.setItem("loggedIn", "true");
                localStorage.setItem("customerId", action.payload.customerId);
                localStorage.setItem("authToken", action.payload.authToken);
                return newState;
                break;

            case constant.USER_LOGOUT:
            	newState.username = "";
            	newState.isLoggedIn = false;
                newState.customerId = "";
                newState.authToken = "";
                localStorage.setItem("username","");
                localStorage.setItem("loggedIn", "false");
                localStorage.setItem("customerId", "");
                localStorage.setItem("authToken", "");
            	return newState;
            	break;

            default:
                 if (localStorage.getItem("loggedIn") == "true") {
                    newState.username = localStorage.getItem("username");
                    newState.customerId = localStorage.getItem("customerId");
                    newState.authToken = localStorage.getItem("authToken");
                    newState.isLoggedIn = true;
                    return newState
                }


        }
        return state;
    }



// WEBPACK FOOTER //
// ./src/reducers/reducer-active-user.js